'use client';

import { useMemo } from 'react';
import { useAllIfData } from './useAllIfData';

/**
 * Get IF data for a specific market index.
 * Derives from the all-markets query.
 */
export function useIfDataQuery(marketIndex: number | undefined) {
	const query = useAllIfData();

	const data = useMemo(
		() => (marketIndex !== undefined ? query.data?.[marketIndex] : undefined),
		[query.data, marketIndex]
	);

	return {
		...query,
		data,
	};
}
